import { clsx } from 'clsx'

type WrapperProps = {
  children: React.ReactNode
}

export default function Wrapper({ children }: WrapperProps) {
  return (
    <div className="affirmation-wrapper cormorant-garamond-font flex h-dvh min-h-dvh grow flex-col overflow-hidden">
      <div
        className={clsx(
          'flex min-h-0 w-full max-w-none min-w-0 shrink grow flex-col items-center',
          'overflow-hidden p-6 md:p-8 lg:p-10 xl:container xl:mx-auto',
        )}
      >
        {children}
      </div>
    </div>
  )
}
